import {
  Checkbox,
  CheckboxGroup,
  type CheckboxGroupProps,
  type CheckboxProps,
  type DateOrTimePickerProps,
  DatePicker,
  FileUploader,
  type FileUploaderProps,
  ImageUploader,
  type ImageUploaderProps,
  Input,
  type InputProps,
  RadioButtonGroup,
  type RadioButtonGroupProps,
  SelectMulti,
  type SelectMultiProps,
  SelectMultiWithTags,
  type SelectMultiWithTagsProps,
  SelectSingle,
  type SelectSingleProps,
  Textarea,
  type TextareaProps,
} from '@cosuno/cosuno-ui';

import { Autocomplete, type AutocompleteProps } from '~/shared/components/Autocomplete';
import CostGroupSelector, {
  type CostGroupSelectorProps,
} from '~/shared/components/CostGroupSelector';
import { DistanceInput, type DistanceInputProps } from '~/shared/components/DistanceInput';
import { EmailField } from '~/shared/components/EmailField';
import FormattedNumberInput, {
  type FormattedNumberInputProps,
} from '~/shared/components/FormattedNumberInput';
import ImagesUploader, { type ImagesUploaderProps } from '~/shared/components/ImagesUploader';
import LocationSearch, { type LocationSearchProps } from '~/shared/components/LocationSearch';
import PhoneInput, { type PhoneInputProps } from '~/shared/components/PhoneInput';
import TextEditor, { type TextEditorProps } from '~/shared/components/TextEditor';
import {
  type Props as WorkCategoriesSelectProps,
  WorkCategoriesSelect,
} from '~/shared/components/WorkCategoriesSelect';

import {
  AgentWorkCategoriesField,
  type AgentWorkCategoriesFieldProps,
} from '../AgentWorkCategoriesField';
import { generateField } from './generateField';
import { StyledNumberInput } from './Styles';

export const Field = {
  Autocomplete: generateField<AutocompleteProps>(Autocomplete),
  Email: EmailField,
  Input: generateField<InputProps>(Input),
  SelectSingle: generateField<SelectSingleProps>(SelectSingle, { markAsTouchedOnChange: true }),
  SelectMulti: generateField<SelectMultiProps>(SelectMulti, { markAsTouchedOnChange: true }),
  SelectMultiWithTags: generateField<SelectMultiWithTagsProps>(SelectMultiWithTags, {
    markAsTouchedOnChange: true,
  }),
  Textarea: generateField<TextareaProps>(Textarea),
  DatePicker: generateField<DateOrTimePickerProps>(DatePicker, { markAsTouchedOnChange: true }),
  LocationSearch: generateField<LocationSearchProps>(LocationSearch),
  CheckboxGroup: generateField<CheckboxGroupProps>(CheckboxGroup, { markAsTouchedOnChange: true }),
  Checkbox: generateField<CheckboxProps>(Checkbox, { markAsTouchedOnChange: true }),
  RadioButtonGroup: generateField<RadioButtonGroupProps<string | number | boolean>>(
    RadioButtonGroup,
    { markAsTouchedOnChange: true },
  ),
  ImageUploader: generateField<ImageUploaderProps>(ImageUploader, { markAsTouchedOnChange: true }),
  ImagesUploader: generateField<ImagesUploaderProps>(ImagesUploader, {
    markAsTouchedOnChange: true,
  }),
  FileUploader: generateField<FileUploaderProps>(FileUploader, { markAsTouchedOnChange: true }),
  FormattedNumberInput: generateField<FormattedNumberInputProps>(FormattedNumberInput),
  DistanceInput: generateField<DistanceInputProps>(DistanceInput),
  NumberInput: generateField<InputProps>(StyledNumberInput),
  PhoneInput: generateField<PhoneInputProps>(PhoneInput),
  WorkCategoriesSelect: generateField<WorkCategoriesSelectProps>(WorkCategoriesSelect),
  TextEditor: generateField<TextEditorProps>(TextEditor),
  AgentWorkCategories: generateField<AgentWorkCategoriesFieldProps>(AgentWorkCategoriesField, {
    hideErrors: true,
  }),
  CostGroupSelector: generateField<CostGroupSelectorProps>(CostGroupSelector),
};
